import {
  IconButton,
  type IconButtonProps,
} from "$components/button/icon-button";
import { BinIcon } from "$components/icons";

export const BinButton = (props: IconButtonProps) => (
  <IconButton color="error" aria-label="delete" title="delete" {...props}>
    <BinIcon fill="currentColor" />
  </IconButton>
);
